import { Resource, ResourceLanguage } from 'i18next'
import translateEN from './locales/en/translation.json'

const resources: Resource = {
    en: {
        translation: translateEN as ResourceLanguage,
    },
}

export default resources
